module.exports = __webpack_public_path__ + "static/money-draw-72f9c72363cc757973d609f9a4d8e30b.svg";